import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { LogoMark } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 tw-grain">
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-5 py-10">
        <div className="mb-4 flex justify-center"><LogoMark className="h-28 w-28 object-contain" /></div>
        <div className="rounded-3xl border-2 border-zinc-950 bg-white p-6 shadow-[6px_6px_0_0_#09090b]">
          <h1 className="font-display text-3xl font-black uppercase text-zinc-950">Recupera password</h1>
          {sent ? (
            <div data-testid="forgot-success" className="mt-4 space-y-3">
              <p className="text-sm text-zinc-600">
                Se l'email è registrata, ti abbiamo inviato un link per reimpostare la password. Controlla la posta (anche lo spam).
              </p>
              <Link to="/login"><Button className="w-full rounded-full bg-green-500 font-bold text-zinc-950 hover:bg-green-600">Torna al login</Button></Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-4 space-y-4">
              <p className="text-sm text-zinc-500">Inserisci la tua email: ti invieremo un link a tempo limitato per il reset.</p>
              <div className="space-y-1.5">
                <Label>Email</Label>
                <Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl" />
              </div>
              <Button data-testid="forgot-submit-button" type="submit" disabled={loading}
                className="w-full rounded-full bg-green-500 py-6 font-black uppercase text-zinc-950 hover:bg-green-600">
                {loading ? "Invio..." : "Invia link di reset"}
              </Button>
              <p className="text-center text-sm"><Link to="/login" className="font-semibold text-zinc-500 hover:text-zinc-950">Annulla</Link></p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
